import { render, staticRenderFns } from "./ApprovalIndex.vue?vue&type=template&id=16c6d8ee&scoped=true&"
import script from "./ApprovalIndex.vue?vue&type=script&lang=js&"
export * from "./ApprovalIndex.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalIndex.vue?vue&type=style&index=0&id=16c6d8ee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c6d8ee",
  null
  
)

export default component.exports